import actions from './actions'

const initialState = {
  dataBuyers: null,
  dataSellers: null,
  dataBreaches: null,
}

const reducer = (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case actions.fetchDataFootprint.SUCCESS_TYPE: {
      const { dataBuyers, dataSellers, dataBreaches } = payload
      return {
        ...state,
        dataBuyers,
        dataSellers,
        dataBreaches,
      }
    }
    default:
      return state
  }
}

export default reducer
